module.exports = __webpack_public_path__ + "static/media/tmc-thumbnail.074723a5.svg";